import { KoCharts, KoPagination, KoSkeleton, KoTable, KoText, KoTitle } from 'packages';
import { useState } from 'react';
// import { PayRollAPI } from '../payroll.service';
import { COLUMN, ROWPAYROLL } from './constant';
import styles from './dashboard.module.scss';
import KoIcon from '@kwapio/icons';
import PayrollCostChartConfig from './payrollCost';
import PayrollDeptCostChartConfig from './departmentcost';
import DepartmentEmployeePieConfig from './departmentEmployeePieConfig';
export default function PayrollDashboard() {



  const [loadingCards ] = useState(false);
  const [dashboardCards ] = useState([
    {
      label: 'Payroll Cost',
      icon: 'UsersFilled',
      arrow: 'ArrowLineUpFilled',
      description: 'Last month',
      value: `2`
    },
    {
      label: 'Total Expense',
      icon: 'RevenueFilled',
      value: `3`,
      description: 'Last month',
      arrow: 'ArrowLineUpFilled'
    },
    {
      label: 'Pending payments',
      icon: 'ClockFilled',
      value: `2`,
      description: 'Last month',
      arrow: 'ArrowLineUpFilled',
      progress: 30
    },
    {
      label: 'Total Payrolls',
      icon: 'ClockFilled',
      value: `3`,
      description: 'Last month',
      arrow: 'ArrowLineUpFilled',
      progress: 30
    },
    {
      label: 'Deductions',
      icon: 'IssueRisedTwoTone',
      value: `3`,
      description: 'Last month',
      burnRate: '₹10 lakh/month',
      arrow: 'ArrowLineUpFilled'
    },
    {
      label: 'Bonuses',
      icon: 'LineUpFilled',
      value: `3`,
      description: 'Last month',
      arrow: 'ArrowLineUpFilled',
      budget: '+₹2 lakh due delay'
    },
    {
      label: 'Total Taxes',
      icon: 'Folder4Filled',
      value: `4`,
      description: 'Last month',
      arrow: 'ArrowLineUpFilled',
      budget: '+₹2 lakh infra cost'
    }
          // {
          //   label: 'Latest Release',
          //   icon: 'PrdFilled',
          //   value: 'Version 1.0',
          //   description: 'Released 1 July 2025',
          //   arrow: 'ArrowLineUpFilled'
          // }
  ]);
  


  return (
    <>
      <div className={styles.wrapper}>
        {/* {isLoading && <KoLoader/>} */}
        <div className={styles.contentBox}>
          {
            !loadingCards && dashboardCards.length > 0 && dashboardCards.map((i) => <div key={i} className={styles.card}>
              <div className={styles.mycontent}>
                <KoText className={styles.label} text={i.label} />
                <div className={styles.content}>
                  <KoTitle level={4} className={styles.value} text={`₹ ${i.value}`} />
                  <div className={styles.descriptionBox}>
                    <KoIcon name={i.arrow} width={16} height={16} />
                    <KoText className={styles.description} text={i.description} />
                  </div>
                </div>
              </div>
            </div>)
          }
          {
            loadingCards && [1, 2, 3, 4, 5, 6, 7].map((i) => <KoSkeleton active={true} key={i} type={'card'} />)
          }
        </div>
        <div className={styles.payrollCostOverview}>
          <div className={styles.cards}>
            <KoTitle text='Payroll Cost' level={5} />
            <KoCharts option={PayrollCostChartConfig()} />
          </div>
          <div className={styles.cards}>
            <KoTitle text='Employee couts' level={5} />
            <KoCharts option={DepartmentEmployeePieConfig()} />
          </div>
        </div>
        <div className={'tableCard'}>
          <KoTitle text='Payroll Summary' level={5} />
          <KoTable data={{ columns: COLUMN, rows: ROWPAYROLL }} maxHeight={75} />
          <KoPagination />
        </div>
        <div className={styles.payrollCostOverview}>
          <div className={styles.cards}>
            <KoTitle text='Department Cost Overview' level={5} />
            <KoCharts option={PayrollDeptCostChartConfig()} />
          </div>
          <div className={styles.cards}>
            <KoTitle text='Bonuses and Deductions' level={5} />
            <KoCharts option={DepartmentEmployeePieConfig()} />
          </div>
        </div>
      
      </div>
          
    </>
  );
}
